import { success } from '@/utils/alert'
import { mapActions } from 'vuex'

export default {
  ...mapActions(['updateUserData', 'updateSettings']),
  doActive () {
    if (!this.user.active) {
      this.$http.put('/v1//profiles/me/account_active')
      .then(({data}) => {
        this.updateUserData(data)
        success('Seja bem vindo. Sentimos sua falta, sua conta acaba de ser reativada.')
      })
      .catch(({data}) => {
        this.errors = data
      })
    }
  },
  doUpdateSetting () {
    this.updateSettings(this.user.settings)
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/resources/methods.js